// extracted by mini-css-extract-plugin
export default {"title":"UserInfo_title__wL2tG","mainContainer":"UserInfo_mainContainer__NLDPN","fontSize":"UserInfo_fontSize__eVZ-5","button":"UserInfo_button__grp2j"};